
export { ShoppingBagButton } from "/codebuild/output/src4239905409/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"